import { AuthenticationService } from '@mapa/core';
import * as i0 from "@angular/core";
import * as i1 from "@mapa/core";
export class SegurancaService {
    constructor(auth) {
        this.auth = auth;
    }
    getUsuarioLogado() {
        return this.auth.getUsuarioLogado();
    }
    isVisualizador() {
        return this.auth.hasPerfil('Visualizador');
    }
    isEstabelecimento() {
        return this.auth.hasPerfil('Estabelecimento');
    }
    isGestor() {
        return this.auth.hasPerfil('Gestor');
    }
    isAnalistaFiscal() {
        return this.auth.hasPerfil('Analista');
    }
}
SegurancaService.ngInjectableDef = i0.defineInjectable({ factory: function SegurancaService_Factory() { return new SegurancaService(i0.inject(i1.AuthenticationService)); }, token: SegurancaService, providedIn: "root" });
